export const me = async (token) => {
    // configure the fetch url
    let url = '/auth/me';

    // if there is a token token, add it to the url
    if (Object.keys(token).length > 0) {
      const tokenString = encodeURIComponent(JSON.stringify(token));
      url += `?token=${tokenString}`;
    }

    const res = await fetch(url);
    
    return await res.json();
};

  export const logout = async() => {
    fetch('/api/analytics/logout', {
      method: 'POST'
    }).then(()=>{
      window.location.href = `${process.env.REACT_APP_URL}/logout`;
    }).catch(()=>{
      window.location.href = `${process.env.REACT_APP_URL}/logout`;
    });
  }


